export default function Footer() {
  return (
    <footer className="py-12 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid sm:grid-cols-3 gap-8 items-center">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg bg-[#c8ff00] flex items-center justify-center">
              <span className="text-surface-900 font-display font-bold text-xs">P</span>
            </div>
            <span className="font-display text-lg font-semibold tracking-tight text-white">
              Prime<span className="text-[#c8ff00]">Web</span>
            </span>
          </div>

          {/* Links */}
          <div className="flex justify-center gap-6">
            {['Work', 'Services', 'About', 'Contact'].map((link) => (
              <a
                key={link}
                href={`#${link.toLowerCase()}`}
                className="font-body text-sm text-surface-500 hover:text-white transition-colors"
              >
                {link}
              </a>
            ))}
          </div>

          {/* Copyright */}
          <div className="text-right">
            <p className="font-body text-sm text-surface-600">
              © 2026 Prime Web. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
